import React, { useEffect } from "react";
import { SfaUserAnalytics } from "../../components/analyticsTable/sfaUserAnalytics";
import DefaultHeading from '../../components/heading/DefaultHeading';
import { eventEnum, logEvent } from "../../services/eventsService/eventService";
import { OrderAnalytics } from "../orderAnalytics/orderAnalytics";
import './userAnalytics.css'
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
export function SfaAnalytics() {
    const { translate } = usePortalTranslation();
    useEffect(() => {
        logEvent(eventEnum.live_dashboard, { feature_name: "SFA Analytics" })
    }, [])
    return (
        <div className="box-container">
            <div className="tile-container">
                <DefaultHeading heading={translate(TranslationEnum.analytics,"User Analytics")} />
                <SfaUserAnalytics />
                <DefaultHeading heading={translate(TranslationEnum.analytics,"Order Analytics")} />
                <OrderAnalytics />
            </div>
        </div>
    );
}